import { makeApiRequest } from "../httpService";
// eslint-disable-next-line no-unused-vars
import { AuditEntrySearchMessage } from "./models/AuditEntrySearchMessage";
// eslint-disable-next-line no-unused-vars
import { AuditEntriesMessage } from "./models/AuditEntriesMessage";
// eslint-disable-next-line no-unused-vars
import { UserDetails } from "../../Sections/Audit/Audit";

export * from "./models/AuditEntriesMessage";
export * from "./models/AuditEntryMessage";
export * from "./models/AuditEntrySearchMessage";

export const getAuditEntries = async (
  searchCriteria: AuditEntrySearchMessage
) => {
  const result = await makeApiRequest<AuditEntrySearchMessage, AuditEntriesMessage>(
    "/auditEntries",
    "POST",
    searchCriteria
  );
  return result;
};

export const getUsers = async () => {
  const result = await makeApiRequest<void, UserDetails[]>(
    "/users",
    "GET"
  );

  return result;
};

export const getBusinessUnits = async () => {
  const result = await makeApiRequest(
    "/businessUnits",
    "GET"
  );
  return result;
};

export const t = 1;
